import React from "react";
import EconomicsWorkspace from "@features/economics/workspace";

export default function EconomicsView():JSX.Element{return <EconomicsWorkspace/>}
